var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("From ( Delivery ) Date "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('fromDate')
    },
    attrs: {
      "id": "fromDate",
      "type": "date",
      "name": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fromDate')),
      expression: "errors.has('fromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("From date is required. ")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "fdate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("To ( Delivery ) Date "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate')
    },
    attrs: {
      "id": "toDate",
      "type": "date",
      "name": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('toDate')),
      expression: "errors.has('toDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("To date is required. ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myReasonModalRef",
    attrs: {
      "id": "#confirmationmodal2",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ReasonModalShow),
      callback: function($$v) {
        _vm.ReasonModalShow = $$v
      },
      expression: "ReasonModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Dispute Reason & AWB No/Amount")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "1%"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "49%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])])])])]), _vm._v(" "), _c('tbody', [(_vm.DisputeArr.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DisputeArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "1%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(val.Reason))]), _vm._v(" "), (val.ReasonAmt) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "49%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables"
    }, [_c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(val.awb.map(function (x) { return Object.keys(x)[0]; }).join(', ')))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(val.ReasonAmt))])])])]) : _vm._e(), _vm._v(" "), (!val.ReasonAmt) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "49%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables"
    }, _vm._l((val.awb), function(row, ind) {
      return _c('tr', [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "25%"
        }
      }, [_vm._v(_vm._s((Object.keys(row)) ? Object.keys(row).toString() : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "11%"
        }
      }, [_vm._v(_vm._s((Object.values(row)) ? Object.values(row).toString() : ''))])])
    }))]) : _vm._e()])
  })], 2)])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myRecExcModalRef",
    attrs: {
      "id": "#confirmationmodal3",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.RecExcModalShow),
      callback: function($$v) {
        _vm.RecExcModalShow = $$v
      },
      expression: "RecExcModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Self Debit/Recovery & Exception AWB No/Amount")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "1%"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "49%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v("AWB Number")])])])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])]), _vm._v(" "), _c('tbody', [(_vm.DisputeArr.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DisputeArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "1%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(val.Reason))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "49%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables"
    }, _vm._l((val.awb), function(row, ind) {
      return _c('tr', [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "25%"
        }
      }, [_vm._v(_vm._s((Object.keys(row)) ? Object.keys(row).toString() : ''))])])
    }))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "11%"
      }
    }, [_vm._v(_vm._s(val.amount))])])
  })], 2)])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myCommentModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.commentModalShow),
      callback: function($$v) {
        _vm.commentModalShow = $$v
      },
      expression: "commentModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.cType))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "0.9rem",
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.comment))])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables scrolltb",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "18",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listSearchSVCledgerData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.pageno + index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.localhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.deliverydate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.depositdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.openingbalance))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.codamount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bankdeposit))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.exceptionamt != 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showRecExcAWBNo('exception', data.exceptionamt, data.awbno)
        }
      }
    }, [_vm._v(_vm._s(data.exceptionamt))]) : _vm._e(), _vm._v(" "), (data.exceptionamt == 0) ? _c('span', [_vm._v(_vm._s(data.exceptionamt))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.cardissueamt != 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showReasonAWBNo(data.cardawbno)
        }
      }
    }, [_vm._v(_vm._s(data.cardissueamt))]) : _vm._e(), _vm._v(" "), (data.cardissueamt == 0) ? _c('span', [_vm._v(_vm._s(data.cardissueamt))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.actualrecamt))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.closingbalance))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.comment) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showComment(data.comment, 'c')
        }
      }
    }, [_vm._v(_vm._s(data.finreason))]) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((['', null].includes(data.comment))),
        expression: "(['',null].includes(data.comment))"
      }]
    }, [_vm._v(_vm._s(data.finreason))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.deposittype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bank))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.files.length > 0) ? _c('span', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer",
        "text-decoration": "underline"
      },
      attrs: {
        "id": ("" + ("vrl"+data.svcledgerid))
      },
      on: {
        "click": function($event) {
          _vm.showHideImages(data.svcledgerid, 'vrl')
        }
      }
    }, [_c('u', [_vm._v("Deposit")])]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": ("" + ("vri"+data.svcledgerid))
      }
    }, _vm._l((data.files), function(file) {
      return _c('a', {
        attrs: {
          "title": ("" + (file.name)),
          "href": ("" + (file.url))
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        staticStyle: {
          "font-size": "20px",
          "color": "#4b8cbb",
          "margin": "10px 10px 1px 1px"
        },
        attrs: {
          "aria-hidden": "true"
        }
      })])
    })), _vm._v(" "), _c('br'), (data.reasonfiles.length > 0) ? _c('span', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer",
        "text-decoration": "underline"
      },
      attrs: {
        "id": ("" + ("vrrl"+data.svcledgerid))
      },
      on: {
        "click": function($event) {
          _vm.showHideImages(data.svcledgerid, 'vrrl')
        }
      }
    }, [_c('u', [_vm._v("Other")])]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": ("" + ("vrri"+data.svcledgerid))
      }
    }, _vm._l((data.reasonfiles), function(file) {
      return _c('a', {
        attrs: {
          "title": ("" + (file.name)),
          "href": ("" + (file.url))
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        staticStyle: {
          "font-size": "20px",
          "color": "#4b8cbb",
          "margin": "10px 10px 1px 1px"
        },
        attrs: {
          "aria-hidden": "true"
        }
      })])
    }))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.transactionid && data.transactionid != 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showComment(data.transactionid, 't')
        }
      }
    }, [_vm._v("view")]) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((['', null, 0].includes(data.transactionid))),
        expression: "(['',null,0].includes(data.transactionid))"
      }]
    })])])
  })], 2)]), _c('br'), _vm._v(" "), (_vm.resultCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    staticClass: " fa fa-filter filter"
  }), _vm._v(" COD SVC Closure Search\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Result")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Hub")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Delivery Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Deposit Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Opening Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("COD Receivable "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Bank Deposited Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Exception AWB Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Finance Confirmed Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Outstanding Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Finance Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Deposit Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Bank Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("View Receipt")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created By")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Transaction Id")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ec84fde","hasScoped":true}!./src/views/components/svcclosuresearch/svcclosuresearch.component.html
// module id = 635
// module chunks = 1